import React, { useCallback, useContext, useRef } from "react";
import {
  Col,
  Row,
  Card,
  Form,
  InputGroup,
  Container,
  Button,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { Context } from "../Keno";

const _FilterForm = () => {
  const { state, dispatch } = useContext(Context);

  const _from = useRef(state.from);
  const _period = useRef(state.period || "");

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload;
  }, []);

  const _handleChangePeriod = useCallback((e) => {
    _period.current = e.target.value;
  }, []);

  const _submitForm = useCallback(() => {
    dispatch({
      type: "SUBMIT_FILTER",
      payload: {
        from: _from.current,
        period: _period.current,
      },
    });
  }, [dispatch]);

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className="align-self-center">
              <h5>KẾT QUẢ KENO</h5>
            </Col>
            <Col className="text-right">
              <Button
                style={{ marginRight: 20 }}
                variant="info"
                type="submit"
                onClick={_submitForm}
              >
                Tìm kiếm
              </Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Container>
            <Col>
              <Row className="p-1">
                <Col>
                  <Row>
                    <Col md={3} className="text-right align-self-center">
                      <Form.Label>Ngày</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Datetime
                        timeFormat={false}
                        onChange={_handleChangeFrom}
                        renderInput={(props, openCalendar) => (
                          <InputGroup>
                            <InputGroup.Text>
                              <FontAwesomeIcon icon={faCalendarAlt} />
                            </InputGroup.Text>
                            <Form.Control
                              required
                              type="text"
                              value={
                                _from.current
                                  ? moment(_from.current).format("DD/MM/YYYY")
                                  : ""
                              }
                              placeholder="dd/mm/yyyy"
                              onFocus={openCalendar}
                              onChange={() => {}}
                            />
                          </InputGroup>
                        )}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row>
                    <Col md={3} className="text-right align-self-center">
                      <Form.Label>Kỳ quay số</Form.Label>
                    </Col>
                    <Col md={9}>
                      <Form.Control
                        type="text"
                        placeholder="Nhập kỳ quay số..."
                        defaultValue={_period.current}
                        onChange={_handleChangePeriod}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Container>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm);
